import { AttachFile } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default ({ func }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("select")} disableTouchListener>
      <IconButton color="primary" size="small" onClick={func}>
        <AttachFile fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};
